import { render, staticRenderFns } from "./modal-desfazer-carga.vue?vue&type=template&id=1d67d27a&scoped=true"
import script from "./modal-desfazer-carga.vue?vue&type=script&lang=ts"
export * from "./modal-desfazer-carga.vue?vue&type=script&lang=ts"
import style0 from "./modal-desfazer-carga.vue?vue&type=style&index=0&id=1d67d27a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d67d27a",
  null
  
)

export default component.exports